export enum ClassificacaoGravidade {
    Leve = 1,
    Moderada,
    Grave
}